module.exports = __webpack_public_path__ + "static/img/1053.cad2374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1053.jpg
// module id = 235
// module chunks = 0